import {useState} from 'react';

//Icons
import HappyCloseIconV2 from '@stencil/icons/src/HappyCloseIconV2/HappyCloseIconV2';

//Components
import DownsellInclusionList from './DownsellInculsionList/DownsellInculsionList';

//Styles
import * as S from './DownsellModal.styles';

//Types
import {InclusionsList, LinkedRatePlanData} from '@stencil/hotels-types/src/details-cg/types';

interface DownsellModalUIProps {
  linkedRateSheetData?: LinkedRatePlanData;
  linkedRPOriginalPriceMsg?: string;
  showPrice?: string;
  tnc?: string;
  linkedInclusionList?: InclusionsList[];
  continueToReviewPageHandler?: VoidFunction;
  onClose?: VoidFunction;
}

const DownsellModal = ({
  linkedRPOriginalPriceMsg,
  linkedRateSheetData,
  showPrice,
  tnc,
  linkedInclusionList,
  continueToReviewPageHandler,
  linkedRPBottomSheetTitle,
  onClose,
}) => {
  return (
    <S.Wrapper>
      <S.Header>
        <S.HeaderTitle
          dangerouslySetInnerHTML={{
            __html: linkedRPBottomSheetTitle,
          }}
        />
        <S.CloseButton onClick={onClose} data-testid="downsell-modal-close">
          <HappyCloseIconV2 />
        </S.CloseButton>
      </S.Header>
      <S.DetailsCard>
        <S.CardTitle
          dangerouslySetInnerHTML={{
            __html: linkedRateSheetData?.ratePlanName,
          }}
        />
        <S.DetailsSection>
          <DownsellInclusionList linkedInclusionList={linkedInclusionList} />
          <S.PricingSection>
            <S.Price> ₹{showPrice}</S.Price>
            <S.Taxes>+{tnc} taxes & fees per night</S.Taxes>
            <S.OrignalPrice dangerouslySetInnerHTML={{__html: linkedRPOriginalPriceMsg}} />
          </S.PricingSection>
        </S.DetailsSection>
      </S.DetailsCard>
      <S.ImportantNote>{linkedRateSheetData?.bottomSheetFooterText}</S.ImportantNote>

      <S.CTASection>
        <S.CTABtn onClick={continueToReviewPageHandler} data-testid="downsell-modal-confirm">
          Continue
        </S.CTABtn>
      </S.CTASection>
    </S.Wrapper>
  );
};

export default DownsellModal;
